import { useState } from 'react';
import { useDidMount } from 'rooks';

// The HubSpot conversations script is loaded by the embed and may not have arrived by the
// time a component mounts, so callers wait on `hsConversationsOnReady` instead of assuming
// the widget is there.
//
// The ready queue is appended to rather than assigned. It is a plain array HubSpot drains
// once, shared by everything on the page — assigning a new one drops whatever else was
// waiting, which is a bug that only shows up the moment a second caller exists.
export const useHubspotChat = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpening, setIsOpening] = useState(false);

  useDidMount(() => {
    if (window.HubSpotConversations) {
      setIsLoaded(true);
      return;
    }

    window.hsConversationsOnReady = [...(window.hsConversationsOnReady ?? []), () => setIsLoaded(true)];
  });

  const loadAndOpen = () => {
    window.HubSpotConversations.widget.load();
    window.HubSpotConversations.widget.open();
  };

  // The widget itself only loads on a press. Pressed before the embed has arrived, the
  // open waits in the ready queue, and `isOpening` covers the gap.
  const openChat = () => {
    if (window.HubSpotConversations) {
      loadAndOpen();
      return;
    }

    if (isOpening) {
      return;
    }

    setIsOpening(true);
    window.hsConversationsOnReady = [
      ...(window.hsConversationsOnReady ?? []),
      () => {
        setIsOpening(false);
        loadAndOpen();
      }
    ];
  };

  return { isLoaded, isOpening, openChat };
};
